
import {
	Component,
	Vue,
	Prop,
	Watch,
	Emit,
	Mixins
} from "vue-property-decorator";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { validationMixin } from "vuelidate";
import {
	required,
	requiredIf,
	minValue,
	maxValue,
	numeric
} from "vuelidate/lib/validators";
import { namespace } from "vuex-class";
import moment from "moment";
import vselect3 from "vselect3";
import AreaTreePicker from "@/components/form/AreaTreePicker.vue";
import { AreaNode } from "@/types/groups/AreaNode";
import { Group } from "@/store/eventqueue/types";
import api from "../../services/api.service";
import { Region } from '@/store/types';

const AlarmPoints = namespace("alarmPoints");
const SiteMonitor = namespace("siteMonitor");

interface ResponseOptions {
title: string,
groupTitle: string,
responseID: number
}

@Component({
	components: {
		VuePerfectScrollbar,
		"area-tree-picker": AreaTreePicker,
		"v-select3": vselect3,
	}
})
export default class AlarmPointFinder extends Vue {

	@Prop({ default: null }) public region: Region | null;

	@AlarmPoints.Getter("getCancelTokenSource") source: any;
	@AlarmPoints.Getter("getResponses") responses: any[];
	@AlarmPoints.Action responseSearch: any;
	@AlarmPoints.Mutation setSelectedResponse: any;
	@AlarmPoints.Mutation setSelectedArea: any;
	@AlarmPoints.Mutation setDisplayResponseId: any;
	@SiteMonitor.Action loadMaskReasonsForAlarmWithRegion: ({ groupID: number, regionURL: string }) => Promise<void>;

	public responseSearchLoading: boolean = false;
	public selectedResponse: any = null;
	public disarmedResponses: any[] = null;
	public responseFilter: string = "";

	@Watch("region")
	private onRegionChanged() {
		this.unviewMasked();
	}

	public get responseArray(): ResponseOptions[]{
		let responseArr = [];
		Object.values(this.responses).map((v) => {
			responseArr.push({title: v.title + ' (' + v.groupTitle + ')',groupTitle: v.groupTitle,responseID: v.responseID});
		})
		return responseArr;
	}

	/**
	 * Handler for when the user selects an item in the area tree.
	 */
	public async setGroup(newGroup: AreaNode | null): Promise<void> {
		const selectedGroup: Group = await this.getGroup(newGroup?.id ?? 0);
		this.setSelectedArea(selectedGroup);
		this.setSelectedResponse(null);
	}

	public async getGroup(groupID: number): Promise<Group> {
		if (groupID === 0) {
			// System Area
			return {
				groupID: groupID,
				parentGroupID: null,
				selected: true,
				title: "System Area" };
		} else {
			return await api.loadGroup(groupID);
		}
	}
	public get filteredDisarmedResponses() {
		if (!this.disarmedResponses) return null;

		if (this.responseFilter == "") return this.disarmedResponses;

		const lowerFilter = this.responseFilter.toLowerCase();

		return this.disarmedResponses.filter(
			response =>
				response.title.toLowerCase().indexOf(lowerFilter) > -1 ||
				response.groupTitle.toLowerCase().indexOf(lowerFilter) > -1
		);
	}

	public async asyncFind(query: string) {
		if (this.source != null) {
			this.source.cancel("Operation cancelled by the user.");
		}

		this.responseSearchLoading = true;
		await this.responseSearch({query, regionURL: this.region.url});
		this.responseSearchLoading = false;
	}

	public async selected(selectedOption: ResponseOptions, id: number) {
		if(selectedOption){
			const responseDetails = await api.responseGet(selectedOption.responseID, this.region.url);
			this.setSelectedResponse(responseDetails);
			this.setSelectedArea(null);

			await this.loadMaskReasonsForAlarmWithRegion({ groupID: responseDetails.groupID, regionURL: this.region.url });
		}
	}
	
	public async viewMasked() {
		this.disarmedResponses = await api.responsesDisarmed(this.region.url);
	}

	public async unviewMasked() {
		this.disarmedResponses = null;
	}

	public async selectDisarmedResponse(response: any) {
		var responseDetails = await api.responseGet(response.responseID, this.region.url);
		this.setSelectedResponse(responseDetails);
		this.setSelectedArea(null);

		this.loadMaskReasonsForAlarmWithRegion({ groupID: responseDetails.groupID, regionURL: this.region.url });
	}

	public async updateResponseStatus(response: any) {
		if (this.disarmedResponses) {
			if (response.armed) {
				let responseIndex = this.disarmedResponses.findIndex(
					disarmedResponse =>
						disarmedResponse.responseID == response.responseID
				);
				if (responseIndex > -1) {
					this.disarmedResponses.splice(responseIndex, 1);
				}
			} else {
				this.disarmedResponses = await api.responsesDisarmed();
			}
		}
	}
}
